import { Link } from "react-router-dom";
import { IconButton } from "../../../../../components/ui";
import { PencilIcon } from "@heroicons/react/24/outline";
import {
  buildExhibitionNavigationTargetUrl,
  getExhibitionListContext,
} from "../../../components/searchResultNavigation";

const Actions = props => {
  const { values } = props || {};
  const { id } = values?.item || values || {};

  if (typeof id == "number") {
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get("status") || "all";
    const href = buildExhibitionNavigationTargetUrl({
      listContext: getExhibitionListContext(window.location.search),
      recordId: id,
      status,
    });

    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={href} title="Edit Exhibition">
              <IconButton variant="clean" title="Edit Exhibition">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
